import { ListItemText, styled, Theme } from '@nexelem/deprecated-theme';
import { FC, SyntheticEvent } from 'react';

const StyledListItem = styled('li')<Pick<ListItemProps, 'isSelected'>>(({ theme, isSelected }) => {
  const typedTheme = theme as Theme;
  const { getColor, hexToRGB } = theme.palette;
  const { internalItem } = typedTheme.client.lists;
  const baseStyles = {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    margin: theme.spacing(1, 0),
    '.MuiListItemText-root': {
      margin: 0,
      '.MuiTypography-root': {
        ...typedTheme.typography.sourceSansPro16Regular,
        padding: theme.spacing(3, 2, 3, 0),
      },
    },
    '.primary-actions:empty + .MuiListItemText-root > .MuiTypography-root': {
      paddingLeft: typedTheme.spacing(4),
    },
    '.secondary-actions > *': {
      ...typedTheme.typography.sourceSansPro16Regular,
      color: getColor(internalItem.defaultState.afterExpandColor),
      padding: theme.spacing(2.5, 2.5),
      borderRadius: '50%',
    },
    '.primary-actions': {
      color: getColor(internalItem.defaultState.afterExpandColor),
      display: 'flex',
      '> button:only-child': {
        padding: theme.spacing(2.5, 2.5),
        marginLeft: theme.spacing(4),
      },
      '> svg:only-child': {
        marginLeft: theme.spacing(4),
      },
      ':has(:nth-of-type(2)) button:first-child': {
        padding: theme.spacing(2.5, 2.5),
        marginLeft: theme.spacing(2),
      },
      'button svg': {
        color: getColor(internalItem.defaultState.actionSVGColor),
      },
      svg: {
        color: getColor(internalItem.defaultState.symbolColor),
      },
      '& >': {
        svg: {
          padding: theme.spacing(3.5, 3.75),
        },
      },
    },
    '&:hover:not(:has(.secondary-actions:hover)):not(:has(.primary-actions:hover))': {
      backgroundColor: hexToRGB(getColor(internalItem.hover.backgroundColor), 0.5),
    },
  };
  if (isSelected) {
    return {
      ...baseStyles,
      '&&': {
        backgroundColor: hexToRGB(getColor(internalItem.selected.backgroundColor), 0.9),
      },
    };
  }

  return baseStyles;
});

type ListItemProps = {
  readonly SecondaryAction?: FC;
  readonly PrimaryAction?: FC;
  readonly isSelected?: boolean;
  readonly primaryText: string;
  onClick?: (evt: SyntheticEvent) => void;
};

export const ListItem = ({
  primaryText,
  isSelected,
  onClick,
  PrimaryAction = () => null,
  SecondaryAction = () => null,
}: ListItemProps) => (
  <StyledListItem isSelected={isSelected}>
    <div className="primary-actions">
      <PrimaryAction />
    </div>
    <ListItemText primary={primaryText} onClick={onClick} />
    <div className="secondary-actions">
      <SecondaryAction />
    </div>
  </StyledListItem>
);
